import { parseStructure, serializeStructure } from '../../core/form-builder/form-structure.js';

/**
 * Form-structure field codec — the page-layer `FieldCodec` wrapper for `type: 'form-builder'`.
 *
 * Thin by design: all semantics (wire⇄UI translation, string-boolean coercion, blank/invalid
 * rules) live in `src/core/form-builder/form-structure.js` so the driver (components) and the
 * factory's validator (pages) share one definition without a boundary violation — parity with
 * how `videos-codec.js` and `videos-driver.js` both share `core/media/youtube-url.js`.
 *
 * Auto-injected by the crud-page factory on `type: 'form-builder'` fields (override by passing an
 * explicit `codec`).
 *
 * - `parse(wire)`: legacy `form_structure` (array from the mock backend, or a JSON string from the
 *   production text column) → keyless UI `FormBuilderFieldset[]`.
 * - `serialize(ui)`: keyless UI model → legacy wire array (string booleans, legacy keys per type,
 *   blanks dropped). Always returns an array (`[] → []`, never `undefined`) so the key is always
 *   sent and clearing all fieldsets persists. The production backend JSON-encodes this array into
 *   the `fb_savedforms.form_structure` text column and derives `form_datatable`/`[aviable]`.
 *
 * @returns {import('../../contracts/forms.js').FieldCodec}
 */
export function createFormStructureCodec() {
  return {
    /** @param {unknown} wireValue */
    parse(wireValue) {
      return parseStructure(wireValue);
    },
    /** @param {unknown} uiValue */
    serialize(uiValue) {
      return serializeStructure(uiValue);
    },
  };
}
